import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuthService, PASSWORD_CHANGE_REQUIRED_CODE } from '@ukam/shell/services/auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();
  const isSignInRequest = request.url.includes('/v5/auth/sign-in');

  if (!token || isSignInRequest) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    })
  ).pipe(
    tap({
      error: (error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          authService.logout();
          return;
        }

        const messages: { code?: string }[] | undefined = error instanceof HttpErrorResponse ? error.error?.messages : undefined;
        if (messages?.some((message) => message.code === PASSWORD_CHANGE_REQUIRED_CODE)) {
          authService.markPasswordChangeRequired();
          router.navigate(['/authentication/change-pwd']);
        }
      },
    })
  );
};
